import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aefdd81e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ticket-header mb-4\" data-v-aefdd81e><div class=\"d-flex align-items-center gap-3 mb-2\" data-v-aefdd81e><div class=\"header-icon\" data-v-aefdd81e><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-aefdd81e><path d=\"M15 5v2\" data-v-aefdd81e></path><path d=\"M15 11v2\" data-v-aefdd81e></path><path d=\"M15 17v2\" data-v-aefdd81e></path><path d=\"M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z\" data-v-aefdd81e></path></svg></div><div data-v-aefdd81e><h2 class=\"mb-0 fw-bold\" data-v-aefdd81e>Create New Ticket</h2><p class=\"text-muted mb-0 mt-1\" data-v-aefdd81e>Submit a support request and we&#39;ll get back to you shortly.</p></div></div></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "logged-in-banner mb-4"
}
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 12 2 2 4-4" })
], -1 /* HOISTED */))
const _hoisted_6 = { class: "ticket-form-card" }
const _hoisted_7 = { class: "form-progress mb-4" }
const _hoisted_8 = { class: "step-circle" }
const _hoisted_9 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" }, null, -1 /* HOISTED */))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-label" }, "Contact Info", -1 /* HOISTED */))
const _hoisted_14 = { class: "step-circle" }
const _hoisted_15 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" }, null, -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-label" }, "Classification", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-circle" }, "3", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "step-label" }, "Details", -1 /* HOISTED */))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: "step1" }
const _hoisted_24 = { class: "section-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold mb-1" }, "Contact Information", -1 /* HOISTED */))
const _hoisted_26 = { class: "text-muted small" }
const _hoisted_27 = { class: "row g-3" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-floating-custom" }
const _hoisted_30 = { class: "form-label-custom" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_32 = {
  key: 0,
  class: "auto-filled-badge"
}
const _hoisted_33 = { class: "input-with-icon" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  class: "input-icon"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "14",
    height: "20",
    x: "5",
    y: "2",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 18h.01" })
], -1 /* HOISTED */))
const _hoisted_35 = ["readonly"]
const _hoisted_36 = {
  key: 0,
  class: "input-status-icon"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#10b981",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 11 3 3L22 4" })
], -1 /* HOISTED */))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 0,
  class: "error-text"
}
const _hoisted_40 = {
  key: 1,
  class: "verified-text"
}
const _hoisted_41 = {
  key: 2,
  class: "readonly-hint"
}
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-floating-custom" }
const _hoisted_44 = { class: "form-label-custom" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_46 = {
  key: 0,
  class: "auto-filled-badge"
}
const _hoisted_47 = { class: "input-with-icon" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  class: "input-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  })
], -1 /* HOISTED */))
const _hoisted_49 = ["readonly"]
const _hoisted_50 = {
  key: 0,
  class: "error-text"
}
const _hoisted_51 = {
  key: 0,
  class: "student-info-card mt-3"
}
const _hoisted_52 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_53 = { class: "student-avatar" }
const _hoisted_54 = { class: "fw-semibold" }
const _hoisted_55 = { class: "text-muted small" }
const _hoisted_56 = {
  key: 0,
  class: "ms-auto"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "logged-in-badge" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" })
  ]),
  /*#__PURE__*/_createTextVNode(" Logged In ")
], -1 /* HOISTED */))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "student-meta" }
const _hoisted_60 = {
  key: 0,
  class: "meta-item"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "10",
    r: "3"
  })
], -1 /* HOISTED */))
const _hoisted_62 = {
  key: 1,
  class: "meta-item"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
], -1 /* HOISTED */))
const _hoisted_64 = {
  key: 2,
  class: "meta-item"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M22 10v6M2 10l10-5 10 5-10 5z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 12v5c3 3 9 3 12 0v-5" })
], -1 /* HOISTED */))
const _hoisted_66 = { key: "step2" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold mb-1" }, "Classification"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "Help us categorize your request.")
], -1 /* HOISTED */))
const _hoisted_68 = { class: "row g-3" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "form-floating-custom" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-custom" }, [
  /*#__PURE__*/_createTextVNode(" Ticket Type (نوع التذكرة) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_72 = { class: "custom-select-wrapper" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select ticket type...", -1 /* HOISTED */))
const _hoisted_74 = ["value"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" })
  ])
], -1 /* HOISTED */))
const _hoisted_76 = {
  key: 0,
  class: "error-text"
}
const _hoisted_77 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_78 = { class: "form-floating-custom" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-custom" }, [
  /*#__PURE__*/_createTextVNode(" Request Type (نوع الطلب) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_80 = { class: "custom-select-wrapper" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select request type...", -1 /* HOISTED */))
const _hoisted_82 = ["value"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" })
  ])
], -1 /* HOISTED */))
const _hoisted_84 = {
  key: 0,
  class: "error-text"
}
const _hoisted_85 = { class: "col-md-6" }
const _hoisted_86 = { class: "form-floating-custom" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-custom" }, [
  /*#__PURE__*/_createTextVNode(" Priority (الأولوية) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_88 = { class: "custom-select-wrapper" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select priority...", -1 /* HOISTED */))
const _hoisted_90 = ["value"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" })
  ])
], -1 /* HOISTED */))
const _hoisted_92 = {
  key: 0,
  class: "error-text"
}
const _hoisted_93 = { class: "col-md-6" }
const _hoisted_94 = { class: "form-floating-custom" }
const _hoisted_95 = { class: "form-label-custom" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */))
const _hoisted_97 = {
  key: 0,
  class: "auto-filled-badge"
}
const _hoisted_98 = { class: "custom-select-wrapper" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select branch...", -1 /* HOISTED */))
const _hoisted_101 = ["value"]
const _hoisted_102 = { class: "select-icon" }
const _hoisted_103 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1 /* HOISTED */))
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#10b981",
  "stroke-width": "2"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "11",
  x: "3",
  y: "11",
  rx: "2",
  ry: "2"
}, null, -1 /* HOISTED */))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1 /* HOISTED */))
const _hoisted_109 = [
  _hoisted_107,
  _hoisted_108
]
const _hoisted_110 = {
  key: 0,
  class: "error-text"
}
const _hoisted_111 = {
  key: 1,
  class: "readonly-hint"
}
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { class: "form-floating-custom" }
const _hoisted_114 = { class: "form-label-custom" }
const _hoisted_115 = {
  key: 0,
  class: "auto-filled-badge"
}
const _hoisted_116 = { class: "custom-select-wrapper" }
const _hoisted_117 = ["disabled"]
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select batch...", -1 /* HOISTED */))
const _hoisted_119 = ["value"]
const _hoisted_120 = { class: "select-icon" }
const _hoisted_121 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1 /* HOISTED */))
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#10b981",
  "stroke-width": "2"
}
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "18",
  height: "11",
  x: "3",
  y: "11",
  rx: "2",
  ry: "2"
}, null, -1 /* HOISTED */))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1 /* HOISTED */))
const _hoisted_127 = [
  _hoisted_125,
  _hoisted_126
]
const _hoisted_128 = {
  key: 0,
  class: "error-text"
}
const _hoisted_129 = {
  key: 1,
  class: "readonly-hint"
}
const _hoisted_130 = { key: "step3" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold mb-1" }, "Ticket Details"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "Describe your issue in detail.")
], -1 /* HOISTED */))
const _hoisted_132 = { class: "row g-3" }
const _hoisted_133 = { class: "col-12" }
const _hoisted_134 = { class: "form-floating-custom" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-custom" }, [
  /*#__PURE__*/_createTextVNode(" Subject (الموضوع) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_136 = { class: "input-with-icon" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  class: "input-icon"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0\n                        0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M18 14h-8" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M15 18h-5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10 6h8v4h-8V6Z" })
], -1 /* HOISTED */))
const _hoisted_138 = {
  key: 0,
  class: "error-text"
}
const _hoisted_139 = { class: "col-12" }
const _hoisted_140 = { class: "form-floating-custom" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label-custom" }, [
  /*#__PURE__*/_createTextVNode(" Description (الوصف) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */))
const _hoisted_142 = { class: "char-counter text-muted small mt-1" }
const _hoisted_143 = {
  key: 0,
  class: "error-text"
}
const _hoisted_144 = {
  key: 0,
  class: "review-summary mt-4"
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold mb-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    class: "me-2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "3"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Review Summary (ملخص المراجعة) ")
], -1 /* HOISTED */))
const _hoisted_146 = { class: "summary-grid" }
const _hoisted_147 = {
  key: 0,
  class: "summary-item"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Student (الطالب)", -1 /* HOISTED */))
const _hoisted_149 = { class: "summary-value" }
const _hoisted_150 = {
  key: 1,
  class: "summary-item"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Program (البرنامج)", -1 /* HOISTED */))
const _hoisted_152 = { class: "summary-value" }
const _hoisted_153 = {
  key: 2,
  class: "summary-item"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Mobile (رقم الهاتف)", -1 /* HOISTED */))
const _hoisted_155 = { class: "summary-value" }
const _hoisted_156 = {
  key: 3,
  class: "summary-item"
}
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Type (النوع)", -1 /* HOISTED */))
const _hoisted_158 = { class: "summary-value" }
const _hoisted_159 = {
  key: 4,
  class: "summary-item"
}
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Request Type (نوع الطلب)", -1 /* HOISTED */))
const _hoisted_161 = { class: "summary-value" }
const _hoisted_162 = {
  key: 5,
  class: "summary-item"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Priority (الأولوية)", -1 /* HOISTED */))
const _hoisted_164 = { class: "summary-value" }
const _hoisted_165 = {
  key: 6,
  class: "summary-item"
}
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Branch (الفرع)", -1 /* HOISTED */))
const _hoisted_167 = { class: "summary-value" }
const _hoisted_168 = {
  key: 7,
  class: "summary-item"
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "Batch (الدفعة)", -1 /* HOISTED */))
const _hoisted_170 = { class: "summary-value" }
const _hoisted_171 = { class: "form-actions mt-4" }
const _hoisted_172 = ["disabled"]
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15 18-6-6 6-6" })
], -1 /* HOISTED */))
const _hoisted_174 = { class: "ms-auto d-flex gap-2" }
const _hoisted_175 = ["disabled"]
const _hoisted_176 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_177 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m9 18 6-6-6-6" }, null, -1 /* HOISTED */))
const _hoisted_179 = [
  _hoisted_178
]
const _hoisted_180 = ["disabled"]
const _hoisted_181 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_182 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  class: "me-1"
}
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m22 2-7 20-4-9-9-4Z" }, null, -1 /* HOISTED */))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M22 2 11 13" }, null, -1 /* HOISTED */))
const _hoisted_185 = [
  _hoisted_183,
  _hoisted_184
]
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "diffcanlt_use" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-0 text-right" }, " لضمان سرعة ودقة متابعة طلبكم، يُرجى استخدام نظام التذاكر، حيث يتم التعامل مع الطلبات من خلاله بشكل أساسي "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-0 text-right" }, [
    /*#__PURE__*/_createTextVNode(" في حال وجود مشكلة تقنية فقط، يمكن التواصل عبر واتساب: "),
    /*#__PURE__*/_createElementVNode("strong", null, "01070726428")
  ])
], -1 /* HOISTED */))
const _hoisted_187 = { class: "success-modal" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
    /*#__PURE__*/_createElementVNode("path", { d: "m9 11 3 3L22 4" })
  ])
], -1 /* HOISTED */))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold mt-3" }, "Ticket Created!", -1 /* HOISTED */))
const _hoisted_190 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small" }, "Our team will review your request and respond shortly.", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" Header "),
      _hoisted_2,
      _createCommentVNode(" Logged-in User Info Banner "),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.isUserLoggedIn && $data.studentVerified)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", null, [
                    _createTextVNode("You are logged in as "),
                    _createElementVNode("strong", null, _toDisplayString($data.form.custom_student_name), 1 /* TEXT */),
                    _createTextVNode(". Your contact information has been auto-filled.")
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Form Card "),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          onSubmit: _cache[15] || (_cache[15] = _withModifiers((...args) => ($options.submitTicket && $options.submitTicket(...args)), ["prevent"]))
        }, [
          _createCommentVNode(" Progress Steps "),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["progress-step", { active: $data.currentStep >= 1, completed: $data.currentStep > 1 }])
            }, [
              _createElementVNode("div", _hoisted_8, [
                ($data.currentStep > 1)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, "1"))
              ]),
              _hoisted_13
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["progress-line", { active: $data.currentStep > 1 }])
            }, null, 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["progress-step", { active: $data.currentStep >= 2, completed: $data.currentStep > 2 }])
            }, [
              _createElementVNode("div", _hoisted_14, [
                ($data.currentStep > 2)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                  : (_openBlock(), _createElementBlock("span", _hoisted_18, "2"))
              ]),
              _hoisted_19
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["progress-line", { active: $data.currentStep > 2 }])
            }, null, 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass(["progress-step", { active: $data.currentStep >= 3 }])
            }, _hoisted_22, 2 /* CLASS */)
          ]),
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              ($data.currentStep === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("p", _hoisted_26, _toDisplayString($data.isUserLoggedIn && $data.studentVerified 
                    ? 'Your contact details have been automatically filled from your account.' 
                    : 'Provide your contact details. We\'ll verify your student record.'), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createCommentVNode(" Mobile Phone (FIRST - so user enters it first) "),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, [
                            _createTextVNode(" Mobile Phone (رقم الهاتف) "),
                            _hoisted_31,
                            ($data.isUserLoggedIn && $data.studentVerified)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, " From Account "))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.form.custom_mobile_phone) = $event)),
                              class: _normalizeClass(["form-input-custom", {
                          'is-invalid': $data.errors.custom_mobile_phone,
                          'is-verified': $data.studentVerified,
                          'is-readonly': $data.isUserLoggedIn && $data.studentVerified
                        }]),
                              readonly: $data.isUserLoggedIn && $data.studentVerified,
                              placeholder: "Enter mobile number",
                              onInput: _cache[1] || (_cache[1] = (...args) => ($options.onMobileInput && $options.onMobileInput(...args))),
                              onBlur: _cache[2] || (_cache[2] = (...args) => ($options.onMobileBlur && $options.onMobileBlur(...args))),
                              onKeypress: _cache[3] || (_cache[3] = (...args) => ($options.preventLettersInTel && $options.preventLettersInTel(...args))),
                              required: ""
                            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_35), [
                              [_vModelText, $data.form.custom_mobile_phone]
                            ]),
                            _createCommentVNode(" Verification status icon "),
                            ($data.studentVerified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                              : _createCommentVNode("v-if", true)
                          ]),
                          ($data.errors.custom_mobile_phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString($data.errors.custom_mobile_phone), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($data.studentVerified && !$data.isUserLoggedIn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, " ✓ Student verified successfully "))
                            : _createCommentVNode("v-if", true),
                          ($data.isUserLoggedIn && $data.studentVerified)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, " Fetched from your account "))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createCommentVNode(" Student Name "),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, [
                            _createTextVNode(" Student Name (اسم الطالب) "),
                            _hoisted_45,
                            ($data.studentVerified)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString($data.isUserLoggedIn ? 'From Account' : 'Auto-filled'), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.form.custom_student_name) = $event)),
                              class: _normalizeClass(["form-input-custom", {
                               'is-invalid': $data.errors.custom_student_name,
                               'is-readonly': $data.studentVerified
                             }]),
                              readonly: $data.studentVerified,
                              placeholder: "Will be auto-filled after verification",
                              required: ""
                            }, null, 10 /* CLASS, PROPS */, _hoisted_49), [
                              [_vModelText, $data.form.custom_student_name]
                            ])
                          ]),
                          ($data.errors.custom_student_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($data.errors.custom_student_name), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]),
                    _createCommentVNode(" Student Info Card (shown after verification) "),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        ($data.studentVerified)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, _toDisplayString($options.getInitials($data.form.custom_student_name)), 1 /* TEXT */),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_54, _toDisplayString($data.form.custom_student_name), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_55, _toDisplayString($data.studentId), 1 /* TEXT */)
                                ]),
                                ($data.isUserLoggedIn)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("div", _hoisted_59, [
                                ($data.form.custom_branch)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                      _hoisted_61,
                                      _createElementVNode("span", null, _toDisplayString($data.form.custom_branch), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_batch)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                      _hoisted_63,
                                      _createElementVNode("span", null, _toDisplayString($data.form.custom_batch), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_program)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                      _hoisted_65,
                                      _createElementVNode("span", null, _toDisplayString($data.form.custom_program), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : ($data.currentStep === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("div", _hoisted_68, [
                        _createCommentVNode(" Ticket Type "),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _createElementVNode("div", _hoisted_72, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.form.ticket_type) = $event)),
                                class: _normalizeClass(["form-select-custom", { 'is-invalid': $data.errors.ticket_type }]),
                                onChange: _cache[6] || (_cache[6] = (...args) => ($options.onTicketTypeChange && $options.onTicketTypeChange(...args))),
                                required: ""
                              }, [
                                _hoisted_73,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options.ticket_type, (opt) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: opt.name,
                                    value: opt.name
                                  }, _toDisplayString(opt.name), 9 /* TEXT, PROPS */, _hoisted_74))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 34 /* CLASS, NEED_HYDRATION */), [
                                [_vModelSelect, $data.form.ticket_type]
                              ]),
                              _hoisted_75
                            ]),
                            ($data.errors.ticket_type)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString($data.errors.ticket_type), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" Request Type (NEW - Conditional based on Ticket Type) "),
                        ($options.requestTypeOptions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("div", _hoisted_80, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.form.custom_request_type) = $event)),
                                    class: _normalizeClass(["form-select-custom", { 'is-invalid': $data.errors.custom_request_type }]),
                                    required: ""
                                  }, [
                                    _hoisted_81,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.requestTypeOptions, (opt) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: opt,
                                        value: opt
                                      }, _toDisplayString(opt), 9 /* TEXT, PROPS */, _hoisted_82))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 2 /* CLASS */), [
                                    [_vModelSelect, $data.form.custom_request_type]
                                  ]),
                                  _hoisted_83
                                ]),
                                ($data.errors.custom_request_type)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString($data.errors.custom_request_type), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Priority "),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _hoisted_87,
                            _createElementVNode("div", _hoisted_88, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.form.priority) = $event)),
                                class: _normalizeClass(["form-select-custom", { 'is-invalid': $data.errors.priority }]),
                                required: ""
                              }, [
                                _hoisted_89,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options.priority, (opt) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: opt.name,
                                    value: opt.name
                                  }, _toDisplayString(opt.name), 9 /* TEXT, PROPS */, _hoisted_90))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 2 /* CLASS */), [
                                [_vModelSelect, $data.form.priority]
                              ]),
                              _hoisted_91
                            ]),
                            ($data.errors.priority)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString($data.errors.priority), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" Branch (readonly if auto-filled) "),
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("label", _hoisted_95, [
                              _createTextVNode(" Branch (الفرع) "),
                              _hoisted_96,
                              ($data.studentVerified && $data.form.custom_branch)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_97, " Auto-filled "))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_98, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.form.custom_branch) = $event)),
                                class: _normalizeClass(["form-select-custom", {
                                'is-invalid': $data.errors.custom_branch,
                                'is-readonly': $data.branchReadonly
                              }]),
                                disabled: $data.branchReadonly,
                                required: ""
                              }, [
                                _hoisted_100,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options.custom_branch, (opt) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: opt.name,
                                    value: opt.name
                                  }, _toDisplayString(opt.name), 9 /* TEXT, PROPS */, _hoisted_101))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 10 /* CLASS, PROPS */, _hoisted_99), [
                                [_vModelSelect, $data.form.custom_branch]
                              ]),
                              _createElementVNode("div", _hoisted_102, [
                                (!$data.branchReadonly)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_103, _hoisted_105))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_106, _hoisted_109))
                              ])
                            ]),
                            ($data.errors.custom_branch)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString($data.errors.custom_branch), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            ($data.branchReadonly)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_111, " Fetched from student record "))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createCommentVNode(" Batch (readonly if auto-filled) "),
                        _createElementVNode("div", _hoisted_112, [
                          _createElementVNode("div", _hoisted_113, [
                            _createElementVNode("label", _hoisted_114, [
                              _createTextVNode(" Batch (الدفعة) "),
                              ($data.studentVerified && $data.form.custom_batch)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_115, " Auto-filled "))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.form.custom_batch) = $event)),
                                class: _normalizeClass(["form-select-custom", {
                                'is-invalid': $data.errors.custom_batch,
                                'is-readonly': $data.batchReadonly
                              }]),
                                disabled: $data.batchReadonly
                              }, [
                                _hoisted_118,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options.custom_batch, (opt) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: opt.name,
                                    value: opt.name
                                  }, _toDisplayString(opt.name), 9 /* TEXT, PROPS */, _hoisted_119))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 10 /* CLASS, PROPS */, _hoisted_117), [
                                [_vModelSelect, $data.form.custom_batch]
                              ]),
                              _createElementVNode("div", _hoisted_120, [
                                (!$data.batchReadonly)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_121, _hoisted_123))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_124, _hoisted_127))
                              ])
                            ]),
                            ($data.errors.custom_batch)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString($data.errors.custom_batch), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            ($data.batchReadonly)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_129, " Fetched from student record "))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ])
                    ]))
                  : ($data.currentStep === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                        _hoisted_131,
                        _createElementVNode("div", _hoisted_132, [
                          _createCommentVNode(" Subject "),
                          _createElementVNode("div", _hoisted_133, [
                            _createElementVNode("div", _hoisted_134, [
                              _hoisted_135,
                              _createElementVNode("div", _hoisted_136, [
                                _hoisted_137,
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.form.subject) = $event)),
                                  class: _normalizeClass(["form-input-custom", { 'is-invalid': $data.errors.subject }]),
                                  placeholder: "Brief summary of your issue",
                                  required: ""
                                }, null, 2 /* CLASS */), [
                                  [_vModelText, $data.form.subject]
                                ])
                              ]),
                              ($data.errors.subject)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_138, _toDisplayString($data.errors.subject), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _createCommentVNode(" Description "),
                          _createElementVNode("div", _hoisted_139, [
                            _createElementVNode("div", _hoisted_140, [
                              _hoisted_141,
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.form.description) = $event)),
                                class: _normalizeClass(["form-textarea-custom", { 'is-invalid': $data.errors.description }]),
                                placeholder: "Please provide as much detail as possible...",
                                rows: "6",
                                required: ""
                              }, null, 2 /* CLASS */), [
                                [_vModelText, $data.form.description]
                              ]),
                              _createElementVNode("div", _hoisted_142, _toDisplayString($data.form.description.length) + " characters ", 1 /* TEXT */),
                              ($data.errors.description)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_143, _toDisplayString($data.errors.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ])
                        ]),
                        _createCommentVNode(" Review Summary "),
                        ($options.hasAnyData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                              _hoisted_145,
                              _createElementVNode("div", _hoisted_146, [
                                ($data.form.custom_student_name)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                      _hoisted_148,
                                      _createElementVNode("span", _hoisted_149, _toDisplayString($data.form.custom_student_name), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_program)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                      _hoisted_151,
                                      _createElementVNode("span", _hoisted_152, _toDisplayString($data.form.custom_program), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_mobile_phone)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                      _hoisted_154,
                                      _createElementVNode("span", _hoisted_155, _toDisplayString($data.form.custom_mobile_phone), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.ticket_type)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                      _hoisted_157,
                                      _createElementVNode("span", _hoisted_158, _toDisplayString($data.form.ticket_type), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" NEW: Request Type in summary "),
                                ($data.form.custom_request_type)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                      _hoisted_160,
                                      _createElementVNode("span", _hoisted_161, _toDisplayString($data.form.custom_request_type), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.priority)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                      _hoisted_163,
                                      _createElementVNode("span", _hoisted_164, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["priority-badge", $options.getPriorityClass($data.form.priority)])
                                        }, _toDisplayString($data.form.priority), 3 /* TEXT, CLASS */)
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_branch)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                      _hoisted_166,
                                      _createElementVNode("span", _hoisted_167, _toDisplayString($data.form.custom_branch), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                ($data.form.custom_batch)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                      _hoisted_169,
                                      _createElementVNode("span", _hoisted_170, _toDisplayString($data.form.custom_batch), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          _createCommentVNode(" Action Buttons "),
          _createElementVNode("div", _hoisted_171, [
            ($data.currentStep > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-secondary-custom",
                  onClick: _cache[13] || (_cache[13] = (...args) => ($options.prevStep && $options.prevStep(...args))),
                  disabled: $data.submitting
                }, [
                  _hoisted_173,
                  _createTextVNode(" Back ")
                ], 8 /* PROPS */, _hoisted_172))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_174, [
              ($data.currentStep < 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn-primary-custom",
                    onClick: _cache[14] || (_cache[14] = (...args) => ($options.nextStep && $options.nextStep(...args))),
                    disabled: $data.validatingMobile || $data.fetchingUserData
                  }, [
                    ($data.validatingMobile || $data.fetchingUserData)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_176))
                      : _createCommentVNode("v-if", true),
                    _createTextVNode(" " + _toDisplayString($data.validatingMobile ? 'Verifying...' : ($data.fetchingUserData ? 'Loading...' : 'Next')) + " ", 1 /* TEXT */),
                    (!$data.validatingMobile && !$data.fetchingUserData)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_177, _hoisted_179))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_175))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "submit",
                    class: "btn-submit-custom",
                    disabled: $data.submitting
                  }, [
                    ($data.submitting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_181))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_182, _hoisted_185)),
                    _createTextVNode(" " + _toDisplayString($data.submitting ? 'Submitting...' : 'Submit Ticket'), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_180))
            ])
          ])
        ], 32 /* NEED_HYDRATION */)
      ]),
      _hoisted_186,
      _createCommentVNode(" Success Modal "),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.showSuccess)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "success-overlay",
                onClick: _cache[17] || (_cache[17] = _withModifiers((...args) => ($options.closeSuccess && $options.closeSuccess(...args)), ["self"]))
              }, [
                _createElementVNode("div", _hoisted_187, [
                  _hoisted_188,
                  _hoisted_189,
                  ($data.createdTicketId)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_190, [
                        _createTextVNode(" Your ticket "),
                        _createElementVNode("strong", null, "#" + _toDisplayString($data.createdTicketId), 1 /* TEXT */),
                        _createTextVNode(" has been submitted successfully. ")
                      ]))
                    : _createCommentVNode("v-if", true),
                  _hoisted_191,
                  _createElementVNode("button", {
                    class: "btn-primary-custom mt-3",
                    onClick: _cache[16] || (_cache[16] = (...args) => ($options.closeSuccess && $options.closeSuccess(...args)))
                  }, " Create Another Ticket ")
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}